/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateDeliverableInput = {
    id: string;
    name?: string | null | undefined;
    description?: string | null | undefined;
    projectId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type UpdateDeliverableMutationVariables = {
    input: UpdateDeliverableInput;
};
export type UpdateDeliverableMutationResponse = {
    readonly updateDeliverable: {
        readonly deliverable: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly description: string | null;
            } | null;
        } | null;
    } | null;
};
export type UpdateDeliverableMutation = {
    readonly response: UpdateDeliverableMutationResponse;
    readonly variables: UpdateDeliverableMutationVariables;
};



/*
mutation UpdateDeliverableMutation(
  $input: UpdateDeliverableInput!
) {
  updateDeliverable(input: $input) {
    deliverable {
      node {
        id
        name
        description
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateDeliverableInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateDeliverablePayload",
    "kind": "LinkedField",
    "name": "updateDeliverable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DeliverableTypeEdge",
        "kind": "LinkedField",
        "name": "deliverable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliverableType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateDeliverableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateDeliverableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UpdateDeliverableMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateDeliverableMutation(\n  $input: UpdateDeliverableInput!\n) {\n  updateDeliverable(input: $input) {\n    deliverable {\n      node {\n        id\n        name\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '460dd5656df8fcce538cc4bc45035d32';
export default node;
